import React, { useState, useEffect } from 'react';
import groupBy from 'lodash/groupBy';
import { FetchRegisterSalesReport, FetchSalesReportDesigner, FetchB2COrderTransactionsDesigner } from '../../fetcher';
import { useHandleAlertMessage } from '../../utils/togglinghooks';
import AlertMessage from '../alertmessages/AlertMessageView';
import { B2COrdersReportTableContainer } from './B2COrdersReportTableContainer'
import { ModalView } from '../_reusedcomponents/ModalView'
import { DetailedOrder } from './DetailedOrder'

const B2COrdersReportContainer = () => {
    const { showAlertMessage, openAlert, closeAlert } = useHandleAlertMessage()
    const [b2COrdersReport, setB2COrdersReport] = useState([])
    const [b2COrdersGroupedReport, setB2COrdersGroupedReport] = useState([])
    const [options, setOptions] = useState([])

    const [showOrder, setShowOrder] = useState(false)
    const handleCloseOrder = () => setShowOrder(false)
    const handleShowOrder = () => setShowOrder(true)
    const [orderToView, setOrderToView] = useState({ order: null, article: null, name: "" })

    const reload = () => {
    }

    //function groupBy(data, key) {
    //    return data.reduce((acc, cur) => {
    //        console.log("Within groupBy", acc, cur, key, cur[key])
    //        acc[cur[key]] = acc[cur[key]] || [];
    //        // if the key is new, initiate its value to an array, otherwise keep its own array value    
    //        console.log("acc[cur[key]]", acc[cur[key]]);
    //        acc[cur[key]].push(cur); return acc;
    //    }, {})
    //}

    useEffect(() => {
        FetchB2COrderTransactionsDesigner(setB2COrdersReport, setOptions, openAlert)
    }, []);

    const handleSubmit = () => {
        FetchB2COrderTransactionsDesigner(setB2COrdersReport, setOptions, openAlert)
    }

    return (
        <>
            <B2COrdersReportTableContainer b2COrdersReport={b2COrdersReport} options={options} setOrderToView={setOrderToView} handleShowOrder={handleShowOrder} />
            <AlertMessage showAlertMessage={showAlertMessage} closeAlert={closeAlert} />
            <ModalView handleShow={showOrder} handleClose={handleCloseOrder} reload={reload}
                modalTitle={window.i18n('manageOrder') + ": "} formTitle={"update-order-form"} handleSubmit={handleSubmit}
                modalBody={<DetailedOrder customerOrder={orderToView} handleCloseOrder={handleCloseOrder} openAlert={openAlert} />} />

        </>
    )

}

export { B2COrdersReportContainer }